import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

export default function Kpi({kpi, title}) {
  return (
          <Card style={{height: 120}} sx={{ boxShadow: 3 }}>
            <CardContent>
                <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                {title}
                </Typography>
                <Typography variant="h5" component="div" gutterBottom>
                {kpi}
                </Typography>
                <Typography variant="body2" >
                <br />                              
                </Typography>
            </CardContent>
            
            </Card>

  );
}